<script>
import Button from '@/components/v3/base/Button';
import TextField from '@/components/v3/base/TextField';
import NavigationName from '@/components/v3/base/NavigatorName';
import { isURL, makeid } from '@/utils';
import EditIcon from '@/assets/icons/edit-02.svg';
import TrashIcon from '@/assets/icons/trash-01.svg';
import CloseIcon from '@/assets/icons/close-icon.svg';

export default {
  components: {
    Button,
    TextField,
    NavigationName,
  },

  props: {
    text: {
      type: String,
      default: '',
    },

    url: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      errors: [{ hasError: false, errorMessage: '' }],
      textDisplay: '',
      link: '',
      isSubmited: false,
      editMode: true,
      randomClass: '',
      isOpen: true,
      loading: true,
      EditIcon,
      TrashIcon,
      CloseIcon,
    };
  },

  watch: {
    text(v) {
      this.textDisplay = v;
    },

    url(v) {
      this.link = v;
      this.editMode = !v;
    },

    link() {
      this.checkValid();
    },
  },

  mounted() {
    this.randomClass = makeid(5);
    setTimeout(() => {
      this.loading = false;
    }, 500);
    this.textDisplay = this.text;
    this.link = this.url;
    this.editMode = !this.url;
    window.addEventListener('click', this.clickOutSide, true);
    this.isOpen = true;
    setTimeout(() => {
      this.isOpen = false;
    }, 100);
  },

  unmounted() {
    window.removeEventListener('click', this.clickOutSide, true);
  },

  methods: {
    checkValid() {
      if (!this.isSubmited) return false;
      if (!this.link) {
        this.errors[0].hasError = true;
        this.errors[0].errorMessage = 'This field is required';
      } else if (isURL(this.link) === 'Not a valid URL.') {
        this.errors[0].hasError = true;
        this.errors[0].errorMessage = 'URL is not valid';
      } else {
        this.errors[0].hasError = false;
        return true;
      }
      return false;
    },

    onSave() {
      this.isSubmited = true;
      if (!this.checkValid()) return;
      if (this.errors.some((error) => error.hasError)) return;
      if (!this.link.includes('http')) this.link = `https://${this.link}`;
      this.$emit('update', {
        text: this.textDisplay.trim() || this.link.trim(),
        link: this.link.trim(),
      });
    },

    onClose() {
      this.$emit('close');
    },

    onEdit() {
      this.editMode = true;
    },

    onRemoveLink() {
      this.$emit('update', {
        text: this.textDisplay.trim() || this.link.trim(),
        link: '',
      });
    },

    clickOutSide(e) {
      if (this.isOpen || this.loading) return;
      const id = `.${this.randomClass}`;
      if (!e.target || !e.target.closest(id.toString())) {
        this.onClose();
      }
    },
  },
};
</script>
<template>
  <div
    class="tw-bg-white tw-shadow-shadow-2 tw-p-6 tw-rounded-lg tw-w-full tw-max-w-form-container-4"
    :class="[randomClass]"
  >
    <div class="tw-absolute tw-top-2 tw-right-3">
      <div class="tw-cursor-pointer tw-text-2xl" @click="onClose">
        <img :src="CloseIcon" />
      </div>
    </div>
    <div v-if="editMode">
      <div class="tw-flex tw-items-center tw-gap-3 tw-pt-4">
        <div class="tw-w-full tw-max-w-22 tw-font-bold">Text to display</div>
        <div class="tw-w-full">
          <TextField
            v-model="textDisplay"
            size="small"
            placeholder="Title of the link (optional)"
          />
        </div>
      </div>
      <div class="tw-mt-3 tw-flex tw-items-start tw-gap-3">
        <div class="tw-w-full tw-max-w-22 tw-font-bold tw-mt-2">URL</div>
        <div class="tw-w-full">
          <TextField
            v-model="link"
            size="small"
            placeholder="http://www.example.com"
            :error="errors[0].hasError"
            :errorMessage="errors[0].errorMessage"
          />
        </div>
      </div>
      <div class="tw-mt-3 tw-flex tw-justify-end">
        <Button size="small" @click="onSave">Save</Button>
      </div>
    </div>
    <div v-else>
      <div class="tw-flex tw-items-center tw-gap-2 tw-pr-6">
        <div class="tw-font-bold tw-whitespace-nowrap">Go to link:</div>
        <div class="tw-w-full tw-text-link-500 tw-max-w-[280px]">
          <a :href="link" target="_blank"><NavigationName :text="link" /></a>
        </div>
        <div class="tw-pr-2">
          <div class="tw-cursor-pointer" @mousedown.prevent="onEdit">
            <img :src="EditIcon" />
          </div>
        </div>
        <div>
          <div class="tw-cursor-pointer" @mousedown.prevent="onRemoveLink">
            <img :src="TrashIcon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
